import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import classnames from 'classnames';

import styles from './loading.css';

const { div } = hh(h);

const Loading = ({ center=false }) => div({className: classnames(styles.container, ! center || styles.center)}, 'Loading …');

export default Loading;



/** WEBPACK FOOTER **
 ** ./src/Loading/index.js
 **/